module.exports = __webpack_public_path__ + "static/img/cash-follow-step.0638d5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cash/cash-follow-step.png
// module id = ZpJF
// module chunks = 1